import {
  EventProfile,
  EventProfileRow,
  Institution,
  VisibilityLimitOptions,
  VisibilityLimitOptionsNonEnterprise,
} from 'cb-model';
import { useFormikContext } from 'formik';
import { FormRow, useCacheRecord } from 'gossamer-front-end';
import { OptionsField } from 'packages/gossamer-unified/types';

interface ControlVisibilityLimitOptionsProps {
  localEventProfile: typeof EventProfile;
}

export const ControlVisibilityLimitOptions = (props: ControlVisibilityLimitOptionsProps): React.JSX.Element | null => {
  const { values } = useFormikContext<{ main: FormRow<EventProfileRow> }>();
  console.log('ControlVisibilityLimitOptions', values.main.institution_id);
  const institutionRecord = useCacheRecord(Institution, values.main.institution_id, !values.main.institution_id);
  // props.localEventProfile.fields.visibility_limit.editable = !!institutionRecord.data;
  (props.localEventProfile.fields.visibility_limit as OptionsField).options =
    institutionRecord.data?.type === 'enterprise' ? VisibilityLimitOptions : VisibilityLimitOptionsNonEnterprise;
  return null;
};
